module.exports = __webpack_public_path__ + "static/img/cart_empty.3dc810b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/cart_empty.png
// module id = +93s
// module chunks = 192